import React from 'react'
import Layout from '../components/layout2'
import Container from '../components/container'
import Vbox from '../components/vbox'
import Top from '../components/top'
import Summary from '../components/summary'
import Button from '../components/button'
import Img from '../components/img'

class RootIndex extends React.Component {
  render() {
    return (
      <Layout>
        <Container>
          <Vbox widegap>
            <Top
              title="Jagharlast.se"
              body="Analysis and update of Sweden's largest portal for book reviews written by children."
              image="/jhl.png"
            />
            <Summary>
              <h4 className="h4">Role</h4>
              <p className="small">UX/UI Design Intern</p>
              <h4 className="h4">Assignment</h4>
              <p className="small">
                Conduct a UX analysis of jagharlast.se and improve a selected
                feature (book review) to optimize user experience.
              </p>
              <h4 className="h4">Tasks</h4>
              <p className="small">
                - Heuristic evaluation <br />
                - User Research <br />
                - Facilitate ideation workshop <br />
                - Sketches and wireframes <br />
                - User testing <br />- Use and add components to design system
                Hi-Fi prototype in Figma.
              </p>
              <h4 className="h4">Results</h4>
              <p className="small">
                - Several high impact/low effort fixes that could be quickly
                implemented for improved user experience. <br />
                - A new interface for the landing page, student login, and a new
                flow for writing & submitting a book review to be implemented in
                2024. <br />- Suggestions for new visual elements
              </p>
              <Button
                to="https://www.figma.com/proto/9OFTtKmSMw3qeNtZmwZDXj/Frida-Runnakko---Portfolio?node-id=741-34188&node-type=canvas&t=LHCSj790oKD9uV3A-8&scaling=min-zoom&content-scaling=fixed&page-id=490%3A1406&starting-point-node-id=741%3A34188&show-proto-sidebar=1&disable-default-keyboard-nav=1&hide-ui=1&fuid=1159438344668895628"
                ariaLabel="View the prototype in Figma"
              >
                Link to prototype {''}
              </Button>
            </Summary>
            <div>
              <h2 className="h2">1 - Background & Overview: </h2>
              <Container narrow>
                <h3 className="h3">Jagharlast.se & LegiLexi</h3>
                <p className="body">
                  The website jagharlast.se was created to give teachers and
                  students a shared platform to increase leisure reading and
                  especially encourage students to read for pleasure during
                  school breaks.{' '}
                </p>
                <p className="body">
                  On jagharlast.se, students can today write and submit book
                  reviews and take on holiday challenges.
                </p>
                <p className="body">
                  Jagharlast.se is run by the non-profit foundation LegiLexi.
                </p>
              </Container>
            </div>

            <div>
              <h2 className="h2">2 - Results:</h2>
              <Container narrow>
                <h3 className="h3">Prototype</h3>
                <h4 className="h4">Hi-Fi prototype</h4>
                <p className="body">
                  The design was based on the existing design system, but I made
                  some adjustments and added new components to improve the user
                  experience.
                </p>
                <Img src="/jhl1.png" caption="Book review flow Hi-Fi" />
                <Img src="/jhl2.png" caption="Landing page Hi-Fi" />
              </Container>
            </div>

            <div>
              <h2 className="h2">3 - Process:</h2>
              <Container narrow>
                <h3 className="h3">Discovery</h3>
                <h4 className="h4">Background</h4>
                <p className="body">
                  The current users of jagharlast.se consist mainly of students
                  at schools that also use LegiLexi's tools to track student
                  reading development, and the number of users is growing
                  steadily each year. This suggests potential for usage of
                  jagharlast.se to also increase. The site has not been updated
                  for several years, which has resulted in outdated design and
                  poor functionality and usability.
                </p>

                <h4 className="h4">Scope</h4>
                <p className="body">
                  Students can both write book reviews and complete holiday
                  challenges on jagharlast.se. After the research work, the book
                  review flow was prioritized as it is more strongly connected
                  to the purpose & goal of jagharlast.se and it was the flow
                  that caused the most pain points.
                </p>
                <h4 className="h4">Research Goals</h4>
                <p className="body">
                  To understand what motivates elementary school students to
                  read and write book reviews & understand what obstacles they
                  encounter on jagharlast.se book review today.
                </p>
                <h4 className="h4">Interviews & Survey</h4>
                <p className="body">
                  I conducted 3 user interviews and sent out a survey to 76
                  teachers and parents of elementary school students who use
                  jagharlast.se and answered questions about what motivates
                  students to read and write book reviews.
                </p>

                <Img
                  src="/jhl3.png"
                  caption="Four themes that crystallized related to writing book reviews"
                />
                <h4 className="h4">Insights</h4>
                <p className="body">
                  I found four themes related to writing book reviews on
                  jagharlast.se where the first theme "see results" was the one
                  mentioned most frequently.{' '}
                </p>
                <ol>
                  <li>See results</li>
                  <li>Competition & rewards</li>
                  <li>Show & share</li>
                  <li>Right level</li>
                </ol>
                <h4 className="h4">
                  Heuristic Evaluation, Usability Testing & Behavior Analysis
                  with Heatmaps
                </h4>
                <p className="body">
                  I conducted a heuristic evaluation to quickly identify
                  potential problems in user experience, conducted usability
                  testing with an elementary school student, and analyzed
                  behavior based on heatmaps that I compiled into a user
                  journey.
                </p>
                <Img
                  narrow
                  src="/jhl4.png"
                  caption="User journey based on insights from research"
                />
                <h4 className="h4">Insights</h4>
                <p className="body">
                  The majority of pain points occurred in the "writing phase"
                </p>
                <ul>
                  <li>Not being able to step back one step at a time</li>
                  <li>Difficult to search for and find the right book</li>
                  <li>
                    Getting no help to correct errors (for example, a required
                    field that was left blank)
                  </li>
                  <li>
                    Some questions are phrased with overly complicated words
                  </li>
                  <li>Difficult to get an overview of your book review</li>
                  <li>
                    Unsatisfactory and unclear feedback when the review was
                    submitted
                  </li>
                </ul>
              </Container>
            </div>
            <div>
              <Container narrow>
                <h3 className="h3">Prioritization and Ideation</h3>
                <h4 className="h4">Workshop</h4>
                <p className="body">
                  After collecting data and insights from users, it was
                  necessary for me to prioritize and develop technically
                  feasible solutions. To achieve this, I facilitated an ideation
                  workshop with product owners, project managers and developers,
                  where we started from How Might We questions formulated based
                  on the insights and problems that emerged during the research
                  phase.{' '}
                </p>
                <h4 className="h4">Workshop Results</h4>
                <p className="body">
                  The solution proposals that were voted on by the participants
                  were prioritized in a high-impact/low-effort matrix, the
                  proposals that ended up in the 1st quadrant could I take to
                  the sketchboard.
                </p>
                <Img
                  narrow
                  src="/jhl5.png"
                  caption="Genius bumps rubbed in the workshop"
                />
                <Img
                  narrow
                  src="/jhl6.png"
                  caption="Solution proposals in an effort/impact matrix"
                />
              </Container>
            </div>

            <div>
              <Container narrow>
                <h3 className="h3">Sketch & Design</h3>
                <h4 className="h4">Hand-drawn sketches and wireframes</h4>
                <p className="body">
                  I am a strong advocate of hand sketches, I think it's an easy
                  way to test ideas where there is less risk of getting stuck in
                  details. In this project, I first made many quick hand
                  sketches and then drew up wireframes in Figma with regular
                  feedback loops.
                </p>

                <Img
                  narrow
                  src="/jhl7.png"
                  caption="Quick hand sketches on student side and review flow"
                />
                <Img
                  narrow
                  src="/jhl8.png"
                  caption="Wireframes on student side and book review flow"
                />
              </Container>
            </div>

            <div>
              <h2 className="h2">4 - Summary:</h2>
              <Container narrow>
                <h3 className="h3">Insights & Learnings</h3>
                <h4 className="h4">Scope & Prioritization</h4>
                <p className="body">
                  You often want to do a lot, and it easily becomes too much. My
                  entry point in the project was to "redesign the entire site"
                  which was also the initial description from the client, but I
                  realized that it became a bit too broad and too big for the
                  limited time I had. It resulted in me taking a bit too big a
                  grip from the beginning when I should have done many user
                  tests instead. It therefore helped to limit myself and focus
                  on the flow for writing book reviews.
                </p>
                <h4 className="h4">Get more perspectives</h4>
                <p className="body">
                  It was incredibly rewarding to get more perspectives and
                  suggestions for solutions from both the project management
                  side and developers to gain an understanding of what is
                  technically and economically feasible.
                </p>
                <h4 className="h4">Test more often</h4>
                <p className="body">
                  Design must always be iterated to improve for the end user. I
                  wish I had had time to test with more users to verify my
                  design.
                </p>
              </Container>
            </div>

            <div>
              <h2 className="h2">More projects:</h2>
              <div className="more-wrapper">
                <div class="more">
                  <img src="/SpeedEats1.png" />
                  <h3 className="h3">SpeedEats</h3>
                  <Button
                    to="/speedeats"
                    ariaLabel="Explore the full project for SpeedEats"
                  >
                    Explore full project
                  </Button>
                </div>
                <div class="more">
                  <img src="/forum.png" />
                  <h3 className="h3">Library Forum</h3>
                  <Button
                    to="/forum"
                    ariaLabel="Explore the full project for Library Forum"
                  >
                    Explore full project
                  </Button>
                </div>
              </div>
            </div>
          </Vbox>
        </Container>
      </Layout>
    )
  }
}

export default RootIndex
